module.exports = __webpack_public_path__ + "img/leftArrow.8eca9826.svg";